import React from 'react';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';

export type SortDir = 'asc' | 'desc';

export const formatRent = (ln: number | null): { text: string; color: string } => {
  if (ln == null) return { text: '—', color: '#8A98A8' };
  const pct = (Math.exp(ln) - 1) * 100;
  return {
    text: `${pct >= 0 ? '+' : ''}${pct.toFixed(4)}%`,
    color: pct === 0 ? '#8A98A8' : pct > 0 ? '#29A152' : '#E51739',
  };
};

export const thSx = {
  fontSize: '11px',
  fontFamily: 'Inter',
  fontWeight: 700,
  color: '#6B7A8D',
  textTransform: 'uppercase' as const,
  letterSpacing: '0.4px',
  py: 0.75,
  px: 1,
  backgroundColor: '#F4F7F9',
  borderBottom: '1px solid #CFD8E5',
  whiteSpace: 'nowrap' as const,
  userSelect: 'none' as const,
};

export const tdSx = {
  fontSize: '12px',
  fontFamily: 'Inter',
  color: '#2D3748',
  py: 0.6,
  px: 1,
  borderBottom: '1px solid #EFF2F5',
};

export interface SortHeaderProps {
  label: string;
  field: string;
  currentField: string;
  currentDir: SortDir;
  align?: 'left' | 'right';
  onSort: (f: string) => void;
}

export const SortHeader: React.FC<SortHeaderProps> = ({
  label,
  field,
  currentField,
  currentDir,
  align = 'right',
  onSort,
}) => {
  const active = currentField === field;
  const Icon = active
    ? currentDir === 'desc'
      ? ArrowDownwardIcon
      : ArrowUpwardIcon
    : UnfoldMoreIcon;

  return (
    <TableCell
      sx={{ ...thSx, textAlign: align, cursor: 'pointer' }}
      onClick={() => onSort(field)}
    >
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.25,
          justifyContent: align === 'right' ? 'flex-end' : 'flex-start',
        }}
      >
        {label}
        <Icon sx={{ fontSize: 13, color: active ? '#2C91AD' : '#B0BEC5' }} />
      </Box>
    </TableCell>
  );
};
